// Panel CLAN del BOX 5 — sigue el mismo patrón visual del PartyPanel/
// GlobalPanel. Header "CLAN ─── N miembros" con el Rogue Frame estable
// + lista de miembros con name + level + clase/raza + estado (online/
// offline + mapa si está online).
//
// Si el user NO está en un clan, el panel muestra un empty state con
// un botón "Ver clanes disponibles" que abre el modal legacy (para el
// flujo de fundar / unirse / aceptar solicitudes — que es UI compleja
// y no encaja en el inline panel).
//
// React.memo nativo. El parent memoiza el JSX via `_getCachedClanPanelEl`.

import React from "react";
import { nameClases, nameRazas } from "../../config/config";

function ClanPanel({
    style,
    clan,
    inviteName,
    onInviteNameChange,
    onSendDialog,
    onOpenLegacyModal,
    onMemberContextMenu
}) {
    const hasClan = !!(clan && clan.hasClan);
    const members = (hasClan && clan.members) || [];
    const isLeader = !!(clan && clan.isLeader);

    return (
        <div className={style.partyPanel}>
            <div className={style.partyPanelHeader}>
                <span className={style.partyPanelTitle}>
                    {hasClan && clan.name ? clan.name : "Clan"}
                </span>
                <span className={style.partyPanelRule} />
                {hasClan && (
                    <span className={style.partyPanelCount}>
                        {members.length}/{clan.memberCap || 6} miembros
                    </span>
                )}
            </div>

            {hasClan ? (
                <>
                    <div className={style.clanMembersListInline}>
                        {members.map((m, idx) => {
                            const cls = nameClases[m.idClase] || "—";
                            const rz = nameRazas[m.idRaza] || "—";
                            const nameColor = m.color || "#3333ff";
                            // Offline tinted: opacidad + grayscale
                            const rowStyle = m.online
                                ? null
                                : { opacity: 0.55, filter: "grayscale(0.7)" };
                            const onCtx =
                                onMemberContextMenu && isLeader && !m.isLeader
                                    ? e => onMemberContextMenu(e, m.name)
                                    : undefined;
                            return (
                                <div
                                    key={m.id || m.name + "_" + idx}
                                    className={style.clanRowInline}
                                    style={rowStyle || undefined}
                                    onContextMenu={onCtx}
                                    title={
                                        isLeader && !m.isLeader && m.online
                                            ? "Click derecho: expulsar"
                                            : undefined
                                    }
                                >
                                    <span className={style.clanColLvl}>
                                        {m.level || "?"}
                                    </span>
                                    <span
                                        className={style.clanColName}
                                        style={{ color: nameColor }}
                                        title={m.name}
                                    >
                                        {m.name}
                                        {m.isLeader && (
                                            <span
                                                className={style.clanLeaderCrown}
                                                title="Líder"
                                            >
                                                {" "}
                                                ♔
                                            </span>
                                        )}
                                    </span>
                                    <span
                                        className={style.clanColClassRace}
                                        title={cls + "/" + rz}
                                    >
                                        {cls.slice(0, 4)}/{rz.slice(0, 4)}
                                    </span>
                                    <span className={style.clanColStatus}>
                                        {m.online ? "Online" : "Off"}
                                    </span>
                                </div>
                            );
                        })}
                    </div>

                    {isLeader && (
                        <div className={style.partyInviteRow}>
                            <input
                                type="text"
                                className={style.partyInviteInput}
                                value={inviteName || ""}
                                onChange={e =>
                                    onInviteNameChange(e.target.value)
                                }
                                onKeyDown={e => {
                                    if (e.keyCode === 13) {
                                        const name = (inviteName || "").trim();
                                        if (!name) return;
                                        onSendDialog("/clan invitar " + name);
                                        onInviteNameChange("");
                                    }
                                }}
                                placeholder="Invitar al clan"
                                maxLength={30}
                            />
                            <button
                                type="button"
                                className={style.partyInviteBtn}
                                onClick={() => {
                                    const name = (inviteName || "").trim();
                                    if (!name) return;
                                    onSendDialog("/clan invitar " + name);
                                    onInviteNameChange("");
                                }}
                            >
                                Invitar
                            </button>
                        </div>
                    )}
                </>
            ) : (
                <div className={style.clanEmptyState}>
                    <div className={style.partyEmpty}>
                        No estás en ningún clan.
                    </div>
                    <button
                        type="button"
                        className={style.partyInviteBtn}
                        onClick={onOpenLegacyModal}
                    >
                        Fundar / Ver clanes
                    </button>
                </div>
            )}
        </div>
    );
}

export default React.memo(ClanPanel);
